import { put, refresh, useApi } from "./api.ts";
import type { Settings } from "./types.ts";

export function useSettings() {
  const s = useApi<Settings>("/api/settings");
  const save = async (values: Record<string, unknown>) => {
    const next = await put<Settings>("/api/settings", values);
    await s.mutate(next, { revalidate: false });
    refresh("/api/discord", "/api/overview", "/api/system");
    return next;
  };
  const get = <T,>(key: string, fallback: T): T => {
    const v = s.data?.[key];
    return v === null || v === undefined ? fallback : (v as T);
  };
  return { ...s, save, get };
}
